module.exports = __webpack_public_path__ + "static/13-5a534b393d52bd86363b27fb07ed2de6.jpg";